// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */
export { mentionsPlugin } from '@atlaskit/editor-plugin-mentions';
export type {
	MentionsPlugin,
	MentionPluginDependencies,
	MentionActions,
	MentionPluginConfig,
	MentionPluginOptions,
	MentionsPluginOptions,
	MentionSharedState,
	MentionsChangedHandler,
	InsertMentionParameters,
} from '@atlaskit/editor-plugin-mentions';
